import { getSignNoToken } from '@/api/order';
import { isWxDevEnv } from '@/utils/tool';
import { defineStore } from 'pinia';
import { isIOS } from 'vant/lib/utils';
import { ref } from 'vue';

const TIMEOUT = 60 * 1000;
const LOCAL_STORAGE_KEY = '__WX_CONFIG__';
export const useWxConfigStore = defineStore(
  LOCAL_STORAGE_KEY,
  () => {
    const iosInitUrl = ref('');
    const isIOSAuth = ref(false);

    const getCurrentPath = () => {
      return window.location.href.split('#')[0];
    };

    /**
     * 检测 URL 是否包含指定的参数
     * @param url - 要检测的 URL
     * @param param - 参数名
     * @param value - 参数值（可选）
     * @returns 是否包含指定参数
     */
    // const hasUrlParam = (url: string, param: string, value?: string): boolean => {
    //   try {
    //     const urlObj = new URL(url);
    //     const paramValue = urlObj.searchParams.get(param);
    //     if (value) {
    //       return paramValue === value;
    //     }
    //     return paramValue !== null;
    //   } catch {
    //     // 如果 URL 解析失败，使用正则表达式作为备选方案
    //     const regex = value
    //       ? new RegExp(`[?&]${param}=${encodeURIComponent(value)}(?:&|$)`)
    //       : new RegExp(`[?&]${param}=([^&]*)`);
    //     return regex.test(url);
    //   }
    // };

    /**
     * 检测 URL 是否需要重新获取（包含 code 和 state=STATE）
     * @param url - 要检测的 URL
     * @returns 是否需要重新获取
     */
    // const shouldRetryUrl = (url: string): boolean => {
    //   return hasUrlParam(url, 'code') && hasUrlParam(url, 'state', 'STATE');
    // };

    /**
     * 延迟执行
     * @param ms - 延迟毫秒数
     */
    // const delay = (ms: number): Promise<void> => {
    //   return new Promise((resolve) => setTimeout(resolve, ms));
    // };

    /**
     * 获取当前 URL，带重试机制
     * 如果 URL 包含 code 和 state=STATE 参数，会重试获取直到获取到干净的 URL
     * @param maxRetries - 最大重试次数，默认 5 次
     * @param retryDelay - 重试间隔，默认 100ms
     * @returns 处理后的 URL
     */
    const getCurrentUrl = async (maxRetries: number = 5, retryDelay: number = 1000): Promise<string> => {
      console.log('获取当前 URL', maxRetries, retryDelay);

      // let retryCount = 0;

      // while (retryCount < maxRetries) {
      //   let url = '';

      //   // 获取基础 URL
      //   if (isIOS()) {
      //     url = iosInitUrl.value || getCurrentPath();
      //   } else {
      //     url = getCurrentPath();
      //   }

      //   // 检查是否需要重试
      //   if (!shouldRetryUrl(url)) {
      //     return url;
      //   }

      //   console.warn(`URL 包含 code 和 state=STATE 参数，第 ${retryCount + 1} 次重试获取...`);

      //   // 延迟后重试
      //   if (retryCount < maxRetries - 1) {
      //     await delay(retryDelay);
      //   }

      //   retryCount++;
      // }

      // 达到最大重试次数，返回当前 URL（可能仍包含问题参数）
      // console.error(`已达到最大重试次数 ${maxRetries}，返回当前 URL`);
      // 开发者工具异常处理
      if (isWxDevEnv()) {
        const url = getCurrentPath();
        return url.split('?')[0];
      }
      return isIOS() ? (iosInitUrl.value || getCurrentPath()) : getCurrentPath();
    };

    const initWechatSDK = async (): Promise<boolean | string> => {
      // eslint-disable-next-line no-async-promise-executor
      return new Promise(async (resolve, reject) => {
        if (!window.wx) {
          reject(new Error('微信 JS-SDK 未初始化'));
          return;
        }
        if (isIOSAuth.value && isIOS() && !isWxDevEnv()) {
          resolve(true);
          return;
        }
        const url = await getCurrentUrl();
        console.log(url, 'url-url');
        // 保存当前 URL 到状态中
        iosInitUrl.value = url;

        const resSign = await getSignNoToken({ url });
        console.log('getSignNoToken', resSign);

        if (resSign?.ErrCode !== 0 || !resSign.Result) {
          reject(new Error(resSign?.ErrMsg ?? '获取微信签名失败'));
          return;
        }
        const params = resSign.Result;

        // 设置超时处理
        const timeout = setTimeout(() => {
          reject(new Error('微信 JS-SDK 初始化超时'));
        }, TIMEOUT);

        window.wx.config({
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: params.appId,
          timestamp: params.timestamp,
          nonceStr: params.nonceStr,
          signature: params.signature,
          jsApiList: params.jsApiList,
        });

        window.wx.ready(() => {
          clearTimeout(timeout);
          console.log('微信 JS-SDK 初始化成功');
          isIOSAuth.value = true;
          resolve(true);
        });

        window.wx.error((error: any) => {
          clearTimeout(timeout);
          console.error('微信 JS-SDK 初始化失败:', error);
          reject(new Error(`微信 JS-SDK 初始化失败: ${error.errMsg || '未知错误'}`));
        });
      });
    };

    const setFirstUrl = (url: string) => {
      console.log('设置初始 URL:', url, isIOS() && !iosInitUrl.value);
      // if (url.includes('code=') && url.includes('state=STATE')) {
      //   console.warn('初始 URL 包含 code 和 state=STATE，忽略设置');
      //   return;
      // }
      iosInitUrl.value = url;
    };

    return {
      iosInitUrl,
      isIOSAuth,
      initWechatSDK,
      setFirstUrl,
    };
  },
);
